import React, { ComponentProps, FunctionComponent } from "react";

const PhoneRingingIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M13.4255 11.1283V12.8485C13.4262 13.0082 13.3934 13.1662 13.3293 13.3125C13.2652 13.4589 13.1712 13.5902 13.0533 13.6982C12.9354 13.8061 12.7962 13.8883 12.6446 13.9395C12.4931 13.9906 12.3325 14.0096 12.1731 13.9953C10.4053 13.8035 8.70723 13.2006 7.21528 12.2349C5.82722 11.3546 4.65038 10.18 3.76835 8.79459C2.79745 7.29873 2.19324 5.59564 2.00466 3.82329C1.99031 3.66473 2.00919 3.50492 2.0601 3.35404C2.11102 3.20316 2.19285 3.06452 2.30039 2.94693C2.40793 2.82935 2.53883 2.7354 2.68474 2.67107C2.83065 2.60675 2.98838 2.57345 3.1479 2.5733H4.87137C5.15017 2.57056 5.42046 2.6691 5.63185 2.85055C5.84325 3.032 5.98132 3.28399 6.02034 3.55953C6.09309 4.11002 6.22799 4.65054 6.42249 5.17076C6.49978 5.37599 6.51651 5.59903 6.47069 5.81346C6.42487 6.02789 6.31842 6.22472 6.16397 6.38062L5.43436 7.10882C6.25218 8.54433 7.44304 9.73292 8.8813 10.5492L9.6109 9.82096C9.7671 9.6668 9.9643 9.56056 10.1791 9.51483C10.394 9.4691 10.6175 9.48579 10.8231 9.56294C11.3443 9.75706 11.8858 9.89171 12.4374 9.96431C12.7165 10.0036 12.9713 10.1439 13.1535 10.3585C13.3357 10.5731 13.4325 10.8471 13.4255 11.1283Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      d: "M9.43286 4.29357C9.99399 4.40283 10.5097 4.67674 10.9139 5.08022C11.3182 5.4837 11.5926 5.99841 11.7021 6.55846M9.43286 2C10.5987 2.12926 11.6858 2.65033 12.5157 3.47763C13.3456 4.30494 13.8691 5.38932 14.0001 6.55273",
    })
  );
};

const ForwardRef = React.forwardRef(PhoneRingingIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
